import { Component } from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';

class ErrorMessage extends Component {
  componentDidMount() {
    message[this.props.type](this.props.children, this.props.delay);
  }

  componentWillUnmount() {
    message.destroy();
  }

  render() {
    return null;
  }
}

ErrorMessage.defaultProps = {
  delay: 10,
  type: 'info',
};

ErrorMessage.propTypes = {
  delay: PropTypes.number,
  type: PropTypes.oneOf(['error', 'loading', 'success', 'warning', 'info']),
  children: PropTypes.any.isRequired,
};

export default ErrorMessage;
